export const install = (component, alias) => {
    const C = component;
    C.install = (app) => {
        app.component(C.name, component);
        if (alias)
            app.config.globalProperties[alias] = component;
    };
    return component;
};
